import CustomLocalStorage from "../lib/localstorage";

const MAX_KIOSKS_TO_STORE = 2;

class HistoryService {

    static saveRecentlyVisitedKiosk(kioskData:any) {
        const { error, storedValue } = CustomLocalStorage.getStoredValue("recentlyVisitedKiosks");
        if(error) return;

        let newRecentlyVisitedKiosks = storedValue || [];

        const alreadyAdded = newRecentlyVisitedKiosks.find((item:any) => {
            return item.kioskId === kioskData.kioskId && item.name === kioskData.name;
        });

        if(alreadyAdded) return;

        if(newRecentlyVisitedKiosks.length < MAX_KIOSKS_TO_STORE) {
            newRecentlyVisitedKiosks.push(kioskData);
        } else {
            newRecentlyVisitedKiosks.pop();
            newRecentlyVisitedKiosks.unshift(kioskData);
        }

        CustomLocalStorage.storeValue("recentlyVisitedKiosks", newRecentlyVisitedKiosks);
    }

    static getRecentlyVisitedKiosks() {
        const { error, storedValue } = CustomLocalStorage.getStoredValue("recentlyVisitedKiosks");
        if(error || !storedValue) return { recentlyVisitedKiosks: [] };
        else return { recentlyVisitedKiosks: storedValue };
    }

}

export default HistoryService;